'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$26(outer) {
  this.b6W = null;
  this.b6U = null;
  this.b6V = false;
  this.b6S = null;
  this.b6T = false;
  this.b6X = false;
  this.b6Y = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.b6W = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_LoginPageView$$anon$26 as $c_Lpresto_LoginPageView$$anon$26 };
$p = $c_Lpresto_LoginPageView$$anon$26.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$26;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$26() {
}
export { $h_Lpresto_LoginPageView$$anon$26 as $h_Lpresto_LoginPageView$$anon$26 };
$h_Lpresto_LoginPageView$$anon$26.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.b6W;
});
$p.t = (function() {
  if ((!this.b6V)) {
    this.b6U = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.b6V = true;
  }
  return this.b6U;
});
$p.ae = (function() {
  if ((!this.b6T)) {
    this.b6S = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().p8(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.b6T = true;
  }
  return this.b6S;
});
$p.w = (function() {
  if ((!this.b6Y)) {
    this.b6X = false;
    this.b6Y = true;
  }
  return this.b6X;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_LoginPageView$$anon$26 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$26, "presto.LoginPageView$$anon$26", ({
  Mi: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$26 as $d_Lpresto_LoginPageView$$anon$26 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$26.js.map
